/**
 * @generated SignedSource<<b1f05c147f68bff68623add23ee661c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utils_useLongestMeetingRecording_meetingRecordings$data = ReadonlyArray<{
  readonly meetingCallEnd: string | null;
  readonly meetingCallStart: string;
  readonly meetingRecordedVideoDuration: number | null;
  readonly " $fragmentType": "utils_useLongestMeetingRecording_meetingRecordings";
}>;
export type utils_useLongestMeetingRecording_meetingRecordings$key = ReadonlyArray<{
  readonly " $data"?: utils_useLongestMeetingRecording_meetingRecordings$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_useLongestMeetingRecording_meetingRecordings">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "utils_useLongestMeetingRecording_meetingRecordings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingCallStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingCallEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoDuration",
      "storageKey": null
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};

(node as any).hash = "61ab9d4109bc0193c0da8116a14e35ed";

export default node;
